import {transparentize} from 'polished';
import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Style.
 */

const StyledMilestoneDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  color: ${(p) => p.theme.palette.blue.shade40};
  margin: 16px 0 0px;
`;

const StyledLineDiv = styled.div`
  height: 1px;
  background-color: ${(p) => transparentize(0.6, p.theme.palette.blue.shade40)};
`;

const StyledContentDiv = styled.div`
  margin: 0 6px;

  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.bold};
  line-height: 17px;
`;

/*
 * Component.
 */

export const ConversationTimelineMilestone: FC = ({children}) => (
  <StyledMilestoneDiv>
    <StyledLineDiv />
    <StyledContentDiv>{children}</StyledContentDiv>
    <StyledLineDiv />
  </StyledMilestoneDiv>
);
